import React from "react";
import ReactDOM from "react-dom";

import { observer, inject, Provider } from "mobx-react";
import { extendObservable } from 'mobx';

import QuantityList     from './QuantityList'
import ProductList      from './ProductList'
import PriceList        from './PriceList'

import styles from './Overview.module.css';


@inject('core')
@observer
export default class Planner extends React.Component {

	componentDidMount() {
		const { core } = this.props
	}

	render() {
		const { core } = this.props

/*
				<div className={styles.column}><QuantityList /></div>
				<div className={styles.column}><ProductList /></div>
*/		
		
		return <div className={styles.overview}>
			<div>
				<ProductList showNeeds={true} showNeedButton={true} filter={ p => core.productFilter || p.needs}  />
			</div>
		</div>
	}

}
